import { Dispatch, SetStateAction, useContext, useState } from 'react'
import { DateTime } from 'luxon'

import { fetchJobInfoThunk, updateJobThunk } from 'features/jobs/slice'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import type { JobNoteType } from 'features/jobs/types'
import { JobPageContext } from 'features/jobs/JobPageContext'
import { jobInfoNotesSelector } from 'features/jobs/selectors'
import { getAuthorizedUser } from 'app/services/LocalStorage'
import { DATE_FORMAT_FOR_NOTES } from '../../consts'
import { JobNoteBlock } from '../styles'
import JobEditNote from '../JobEditNote'

interface JobNewNoteProps {
  setCreateNewNote: Dispatch<SetStateAction<boolean>>
}

function JobNewNote({ setCreateNewNote }: JobNewNoteProps) {
  const dispatch = useAppDispatch()
  const { jobId } = useContext(JobPageContext)
  const initialNotes = useAppSelector(jobInfoNotesSelector)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const handleCreateNewNote = async (newText: string) => {
    const storedUser = getAuthorizedUser()
    if (!newText || newText.length === 0 || !storedUser?.email) {
      return
    }
    try {
      setIsLoading(true)
      const date = DateTime.utc().toFormat(DATE_FORMAT_FOR_NOTES).toString()
      const newNote: JobNoteType = {
        authorEmail: storedUser.email,
        creationDate: date,
        editDate: date,
        text: newText,
      }

      await dispatch(
        updateJobThunk({
          domainId: jobId,
          payload: { notes: [...initialNotes, newNote] },
        })
      )
      await dispatch(fetchJobInfoThunk(jobId))
      setIsLoading(false)
      setCreateNewNote(false)
    } catch (err) {
      setIsLoading(false)
      setIsError(true)
      console.log('Error updating job notes', err)
    }
  }

  return (
    <JobNoteBlock>
      <JobEditNote
        isNewNote
        isError={isError}
        isLoading={isLoading}
        handleClose={() => setCreateNewNote(false)}
        handleSubmit={handleCreateNewNote}
      />
    </JobNoteBlock>
  )
}

export default JobNewNote
